import React, { Component } from 'react'
import { View, StyleSheet, Platform } from 'react-native'
import { JDText, JDImage, JDDevice, JDTouchable, JDNativeSystem,JDMta } from '@jdreact/jdreact-core-lib'
import PropTypes from "prop-types"
import {callPhone} from '../../../utils/callPhone'
import telCallNew from '../../../images/detail/tell_buttonnew.png'
import infoCardIMg from '../../../images/detail/info_card.png'
import businessLicenseImg from '../../../images/detail/business_license.png'
import brokerLabelImg from '../../../images/detail/broker_img.png'

// 经纪人头像brokerPic,经纪人姓名brokerName,经纪人公司名称brokerCompany,报价brokerQuote,中介费率agencyRate,中介电话brokerTel
export default class brokerItem extends Component{
	static contextTypes = {
		router: PropTypes.object
	};
	static propTypes = {
		brokerInfo: PropTypes.object,
		index: PropTypes.number,
		isFooter: PropTypes.bool
	};
	isBrokerPage = () => { // 判断是否是房源描述页
		if (Platform.OS === 'web') {
			if (window.location.pathname == "/brokerInfo")  return true;
		} else {
			let routes = this.context.router.getCurrentRoutes();
			if(routes[routes.length-1].routeName == "brokerInfo") return true;
		}
		return false;
	};
	// 渲染报价和中介率
	brokerSecondInfo = () => {
		let {company} = this.props.brokerInfo || {};
		let {isFooter} = this.props;
		if (company) {
			return (
				isFooter ? <View style={brokerStyles.brokerFComBox}><JDText style={brokerStyles.brokerFComText}>{company}</JDText></View> : <View style={brokerStyles.brokerComBox}><JDText style={brokerStyles.brokerComText}>来自{company}</JDText></View>
			)
		} else {
			return null;
		}
	};
	// 唤起打电话功能
	telCall = () => {
		let {brokerInfo, cityId, skuid, spuName, isFooter} = this.props;
		callPhone(brokerInfo);
		if (isFooter){
			let json_param = JSON.stringify({
				skuid: skuid,
				cityid: cityId,
				broker_name: brokerInfo.name || ''
			})
			JDMta.sendClickDataWithJsonParam("SHouse_HouseDetail_phone",'',	"", 	"https://esfr.m.jd.com/housedetail",	"",	"", "SHouse_HouseDetail",	"", json_param);
		} else {
			JDMta.sendClickData("SHouse_AgentTelConsult",'cityId:'+cityId+',skuid:'+(skuid || '')+',spuName:'+spuName,	"", 	"",	"",	"", "SHouse_HouseDetail",	"");
		}
	};
	// 对后端传过来的电话号码进行处理
	curTel(brokerInfo) {
		let extensionPhone = brokerInfo.extensionPhone ? brokerInfo.extensionPhone : ''; // 经纪分机电话号码
		let extensionNum = brokerInfo.extensionNum ? ',' + brokerInfo.extensionNum : ''; // 经纪人分机号
		let phoneNum = brokerInfo.phoneNum ? brokerInfo.phoneNum : ''; // 经纪人电话
		let currentTel = '';
		if (extensionPhone && extensionNum) {
			currentTel = extensionPhone + extensionNum;
		} else if (extensionPhone && !extensionNum) {
			currentTel = extensionPhone;
		} else {
			currentTel = phoneNum;
		}
		return currentTel;
	};
	toViewBrokerInfo(postUrl) { // 经纪人表上的信息卡或营业执照
		this.props.viewBrokerInfo(postUrl);
	}
	render() {
		let {
			headImg, name, businessLicense, infoCard,companyLogo, 
			expertBroker, // 是否是置业专家
			employedProve // 置业专家从业证明
		} = this.props.brokerInfo || {};
		let displayedInfoCard = null;
		if (expertBroker) {
			displayedInfoCard = employedProve || null;
		} else {
			displayedInfoCard = infoCard || null;
		}
		return (
				<View style={this.props.index === 0 ? brokerStyles.brokerContainer :brokerStyles.Linenew}>
					<View style={brokerStyles.imgBox}>
						<JDImage
								style={brokerStyles.headPic}
								source={{uri:'https://m.360buyimg.com/mobilecms/'+headImg}}
						></JDImage>
						{
							expertBroker && (
									<JDImage
											style={brokerStyles.brokerLabel}
											source={brokerLabelImg}
									></JDImage>
							)
						}
					</View>
					<View style={[brokerStyles.brokerRight]}>
						<View style={brokerStyles.brokerMes}>
							<View style={[brokerStyles.brokerRow,{marginBottom: JDDevice.getRpx(4),height: JDDevice.getRpx(45)}]}>
									<JDText numberOfLines={1} ellipsizeMode={'tail'} style={brokerStyles.brokerName}>{name}</JDText>
									{!!companyLogo&&(<JDTouchable style={brokerStyles.companyLogoTouch} onPress={() => {}}>
									<JDImage style={brokerStyles.companyLogoImg} source={{uri:'https://m.360buyimg.com/mobilecms/'+companyLogo}}></JDImage>
									</JDTouchable>)}
									{!!displayedInfoCard && (<JDTouchable style={brokerStyles.brokerInfoTouch} onPress={() => {this.toViewBrokerInfo(displayedInfoCard)}}><JDImage style={brokerStyles.brokerInfoImg} source={infoCardIMg}></JDImage>
									</JDTouchable>)}
									{!!businessLicense && (<JDTouchable style={brokerStyles.brokerInfoTouch} onPress={() => {this.toViewBrokerInfo(businessLicense)}}><JDImage style={brokerStyles.brokerInfoImg} source={businessLicenseImg}></JDImage></JDTouchable>)}
							</View>
							{this.brokerSecondInfo()}
						</View>
					</View>
					<JDTouchable style={brokerStyles.telCallCon} onPress={this.telCall}>
							{
								this.props.isFooter ? <View style={brokerStyles.footerTelBox}><JDText style={brokerStyles.footerTel}>打电话</JDText></View> : 
								<JDImage style={brokerStyles.telCall} source={telCallNew}></JDImage>
							}
						</JDTouchable>
					</View>
		)
	}
}
const brokerStyles = StyleSheet.create({
	brokerContainer:{
		display: 'flex',
		flexDirection:'row',
		width: '100%',
		height: JDDevice.getRpx(120),
		paddingBottom: JDDevice.getRpx(30),
		borderTopWidth: JDDevice.getDpx(1),
		borderStyle: 'solid',
		borderColor: '#ffffff'
	},
	imgBox: {
		position: 'relative',
		width: JDDevice.getRpx(90),
		alignItems: 'center'
	},
	headPic:{
    width:JDDevice.getRpx(90),
		height:JDDevice.getRpx(90),
		borderRadius: JDDevice.getRpx(46)
  },
	brokerLabel: {
		position: 'absolute',
		bottom: JDDevice.getRpx(-5),
		left: JDDevice.getRpx(-4),
		width: JDDevice.getRpx(100),
		height: JDDevice.getRpx(28)
	},
	brokerRight:{
		flex:1,
		flexDirection:'row',
		marginLeft: JDDevice.getRpx(24),
		maxWidth: JDDevice.getRpx(340),
	},
	Linenew: {
		display: 'flex',
		flexDirection:'row',
		width: '100%',
		height: JDDevice.getRpx(150),
		paddingBottom: JDDevice.getRpx(30),
		paddingTop: JDDevice.getRpx(30),
		borderTopWidth: JDDevice.getDpx(1),
		borderStyle: 'solid',
		borderColor: '#E3E5E9'
	},
	brokerMes:{
		flex: 1,
		// width:JDDevice.getRpx(396),
		height: JDDevice.getRpx(89),
		justifyContent:"center"
	},
	brokerRow: {
		flexDirection:'row',
		alignItems: "center",
		height: JDDevice.getRpx(40),
	},
	brokerName:{
		fontSize: JDDevice.getRpx(28),
		marginRight: JDDevice.getRpx(10),
		maxWidth: JDDevice.getRpx(174),
		fontWeight: 'bold',
		color: '#424854'
	},
	brokerCompany:{
		fontSize: JDDevice.getRpx(28),
		color: '#848689',
	},
	brokerComBox: {
		flexDirection:'row',
		alignItems: "center",
		height: JDDevice.getRpx(40),
	},
	brokerComText: {
		fontSize: JDDevice.getRpx(28),
		color: '#848689',
	},
	brokerFComBox: {
		flexDirection:'row',
		alignItems: "center",
		height: JDDevice.getRpx(37),
	},
	brokerFComText: {
		fontSize: JDDevice.getRpx(24),
		color: '#888888',
		backgroundColor: '#F6F6F6',
		paddingHorizontal: JDDevice.getRpx(9),
    paddingVertical: JDDevice.getRpx(6),
	},
	brokerPriceStrong: {
		fontSize: JDDevice.getRpx(28),
		color: '#FA2C19'
	},
	telCallCon:{
		position: 'absolute',
		bottom: JDDevice.getRpx(30),
		right: 0
	},
	telCall:{
		marginBottom: JDDevice.getRpx(14),
		width:JDDevice.getRpx(60),
		height:JDDevice.getRpx(60),
	},
	brokerInfoTouch: {
		width:JDDevice.getRpx(42),
		height:JDDevice.getRpx(28),
		marginRight: JDDevice.getRpx(12)
	},
	brokerInfoImg: {
		width:JDDevice.getRpx(40),
		height:JDDevice.getRpx(28),
		resizeMode: 'contain'
	},
	footerTelBox: {
		flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
		width:JDDevice.getRpx(168),
		height:JDDevice.getRpx(88),
		borderRadius: JDDevice.getRpx(44),
		backgroundColor: '#FA2C19',
	},
	footerTel: {
		color: '#ffffff',
		fontSize: JDDevice.getRpx(32),
		textAlign: 'center',
	},
	companyLogoTouch: {
		width:JDDevice.getRpx(36),
		height:JDDevice.getRpx(36),
		marginRight: JDDevice.getRpx(8)
	},
	companyLogoImg: {
		width:JDDevice.getRpx(36),
		height:JDDevice.getRpx(36)
	}

});
